import React from "react";
import {
  CalendarRange,
  MapPin,
  Phone,
  Wallet,
  FileBarChart2,
  Building,
} from "lucide-react";

const LedgerHeader = ({ customerInfo }) => {
  const formatCurrency = amount => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <div className="flex justify-between items-start">
        <div className="space-y-4">
          <div className="flex items-center">
            <Building className="text-gray-500 mr-2" size={20} />
            <h2 className="text-xl font-semibold text-gray-800">
              {customerInfo.firmName}
            </h2>
          </div>

          <div className="space-y-2 text-gray-600">
            <div className="flex items-center">
              <MapPin className="text-gray-400 mr-2" size={16} />
              <span className="text-sm">{customerInfo.address}</span>
            </div>

            {customerInfo.phoneNumber && (
              <div className="flex items-center">
                <Phone className="text-gray-400 mr-2" size={16} />
                <span className="text-sm">{customerInfo.phoneNumber}</span>
              </div>
            )}

            {customerInfo.gstin && (
              <div className="flex items-center">
                <FileBarChart2 className="text-gray-400 mr-2" size={16} />
                <span className="text-sm">GSTIN: {customerInfo.gstin}</span>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col items-end space-y-3">
          <div className="flex items-center bg-gray-50 px-4 py-2 rounded-md">
            <CalendarRange className="text-gray-500 mr-2" size={18} />
            <span className="text-sm font-medium">
              {customerInfo.period.from} to {customerInfo.period.to}
            </span>
          </div>

          <div className="flex items-center bg-purple-50 px-4 py-2 rounded-md">
            <Wallet className="text-purple-500 mr-2" size={18} />
            <div>
              <span className="text-xs text-gray-500 block">
                Opening Balance
              </span>
              <span className="text-base font-medium text-gray-800">
                {formatCurrency(customerInfo.openingBalance)}{" "}
                {customerInfo.balanceType}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LedgerHeader;
